interface GenderBadge {
  label: string;
  className: string;
}

const GENDER_BADGES: Record<number, GenderBadge> = {
  1: { label: 'Menino', className: 'text-olivine-dark' },
  2: { label: 'Menina', className: '' },
  4: { label: 'Unissex', className: 'text-chocolate-dark' },
};

export function getGenderBadge(gender: number): GenderBadge | null {
  return GENDER_BADGES[gender] ?? null;
}
